var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSbEmployeesUnselected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 22,
    viewBox: "0 0 30 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.75 11C23.82 11 25.485 9.32 25.485 7.25C25.485 5.18 23.82 3.5 21.75 3.5C19.68 3.5 18 5.18 18 7.25C18 9.32 19.68 11 21.75 11ZM10.5 9.5C12.99 9.5 14.985 7.49 14.985 5C14.985 2.51 12.99 0.5 10.5 0.5C8.01 0.5 6 2.51 6 5C6 7.49 8.01 9.5 10.5 9.5ZM21.75 14C19.005 14 13.5 15.38 13.5 18.125V20C13.5 20.825 14.175 21.5 15 21.5H28.5C29.325 21.5 30 20.825 30 20V18.125C30 15.38 24.495 14 21.75 14ZM10.5 12.5C7.005 12.5 0 14.255 0 17.75V20C0 20.825 0.675 21.5 1.5 21.5H10.5V18.125C10.5 16.85 10.995 14.615 14.055 12.92C12.75 12.65 11.49 12.5 10.5 12.5Z",
    fill: "#F4F4F4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSbEmployeesUnselected);
export default __webpack_public_path__ + "static/media/SBEmployeesUnselected.2d4fc752538a6e04a236c87da8960281.svg";
export { ForwardRef as ReactComponent };